import { App } from './../components/app';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return {
        order: state.shopState.order,
        message: state.appState.message,
        setting: state.appState.setting,
        modals: state.rightModalState.activeModals,
        miniModals: state.miniModalState.activeModals,
        extraModals: state.rightModalState.activeExtraModals,
        menu: state.appState.stateMenu.isOpen,
        point: state.shopState.order.point,
    };
};

const dispatchToProps = (dispatch) => {
    return {
        dispatch,
        delMessage: () => {
            dispatch({ type: 'delMessage' });
        },
        toggleOpenLeftMenu: () => {
            dispatch({ type: 'toggle_open_menu' });
        },
    };
};

export const AppLink = connect(mapStateToProps, dispatchToProps)(App);
